module.exports = __webpack_public_path__ + "static/media/blogexit1.db15f53a.svg";